import { action, observable, makeAutoObservable } from 'mobx';

class ModerationMenuStore {
    @observable public openMenuParticipantSid: string | null = null;

    public constructor() {
        makeAutoObservable(this);
    }

    @action
    public setOpenMenu = (participantSid: string | null) => {
        this.openMenuParticipantSid = participantSid;
    };

    @action
    public closeMenu = () => {
        this.openMenuParticipantSid = null;
    };
}

export const moderationMenuStore = new ModerationMenuStore();
